import store from "src/store";
import ModulEnum from "src/enums/ModulEnum";

export const checkAuthByType = (authCode: string, modul: ModulEnum): boolean => {
    if (!authCode)
        return true;
    const controlAuths = store.getState().controlAuth.data;
    return controlAuths.filter(auth => auth.authCode === authCode && auth.modulId == modul && auth.authVal === 1)?.length > 0;
}

export const isVisible = (authCode: string, modul: ModulEnum): boolean => checkAuthByType(authCode, modul);